import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { LobbyMessage } from '@/types/supabase';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface MessageReactionsProps {
  message: LobbyMessage;
  onToggleReaction: (emoji: string) => void;
}

const MessageReactions: React.FC<MessageReactionsProps> = ({ message, onToggleReaction }) => {
  const { user } = useAuth();
  const reactions = message.reactions;

  if (!reactions || Object.keys(reactions).length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-1 mt-2">
      {Object.entries(reactions).map(([emoji, data]) => {
        if (data.user_ids.length === 0) return null;
        
        const currentUserReacted = user ? data.user_ids.includes(user.id) : false;

        return (
          <Button
            key={emoji}
            variant="outline"
            size="sm"
            className={cn(
              "h-auto px-2 py-1 rounded-full text-xs transition-colors",
              currentUserReacted && "bg-primary/20 border-primary hover:bg-primary/30"
            )}
            onClick={() => onToggleReaction(emoji)}
          >
            {data.imageUrl ? (
              <img src={data.imageUrl} alt={emoji} className="h-4 w-4 mr-1.5" />
            ) : (
              <span className="mr-1.5 text-sm">{emoji}</span>
            )}
            <span className="font-semibold">{data.user_ids.length}</span>
          </Button>
        );
      })}
    </div>
  );
};

export default MessageReactions;